export enum ProfessionalTypeEnum {
  Doctor = "DOCTOR",
  HealthcareProfessional = "HEALTHCARE_PROFESSIONAL",
  Other = "OTHER",
}

export enum AccountRoleEnum {
  DefaultUser = "DEFAULT_USER",
  AdminUser = "ADMIN_USER",
}

export enum DeviceStatusEnum {
  WAITING = 'WAITING',
  CONNECTED = 'CONNECTED',
  ABORTED = 'ABORTED'
}

export enum ConversationPriorityEnum {
  LOW = 'LOW',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM'
}

export enum MessageTypeEnum {
  text = 'text',
  audio = 'audio',
  image = 'image',
  video = 'video',
  document = 'document'
}

export enum ConversationTypeEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP'
}

export enum ParticipantRoleEnum {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

export enum ConversationFilterEnum {
  LOW = 'LOW',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  ALL = 'ALL',
  NO_PRIORITY = 'NO_PRIORITY',
  GROUP = 'GROUP'
}

export enum MessageStatusEnum {
  DELIVERY_ACK = 'DELIVERY_ACK',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  PLAYED = 'PLAYED',
  READ = 'READ',
  SERVER_ACK = 'SERVER_ACK',
  FAILED = 'FAILED'
}

export enum DateRangeEnum {
  LAST_2_HOURS = 'last2h',
  LAST_12_HOURS = 'last12h',
  LAST_24_HOURS = 'last24h',
  LAST_7_DAYS = 'last7d',
  LAST_30_DAYS = 'last30d',
  CUSTOM = 'custom'
}
